/**
 * Created by Andrey Popov on 25/2/20.
 */

const MessageSeparatorView = cc.Node.extend({
    ctor: function (chatMessage) {
        this._super();

        this.chatMessage = chatMessage;

        this.setAnchorPoint(0, 0.5);

        this.line = cleverapps.UI.createScale9Sprite(bundles.chat.frames.dialogue_separator);
        this.addChild(this.line);

        this.onResize();
    },

    onResize: function () {
        const styles = cleverapps.styles.MessageSeparatorView;
        this.setContentSize2(cleverapps.resolution.getSceneSize().width, styles.height);

        this.line.setContentSize(cleverapps.resolution.getSceneSize().width - 2 * styles.line.padding, styles.line.height);
        this.line.setAlignment(this.width / 2, this.height / 2);
    }
});

cleverapps.styles.MessageSeparatorView = {
    height: 50,
    line: {
        height: 3,
        padding: 40
    }
};